export default {
  displayName: {
    label: 'Nazwa',
    tooltip: 'Wyświetlana nazwa kanału powiadomień',
  },
  description: {
    label: 'Opis',
    tooltip: 'Opis kanału powiadomień',
  },
  senderEmail: {
    label: 'E-mail nadawcy',
    tooltip: 'Adres e-mail nadawcy, którego należy użyć',
  },
  serverHost: {
    label: 'Serwer pocztowy',
    tooltip: 'Host serwera SMTP',
  },
  serverPort: {
    label: 'Port SMTP',
    tooltip: 'Port serwera SMTP',
  },
  useSsl: {
    label: 'Użyj SSL',
    tooltip: 'Czy Użyj protokołu SSL',
  },
  credential: {
    label: 'Mandat',
    tooltip: 'Ustaw lub utwórz dane uwierzytelniające.',
    setCredential: 'Ustaw dane uwierzytelniające',
    updatingcredential: 'Aktualizuj dane uwierzytelniające',
    credentialUpdated: 'Dane uwierzytelniające zostaną zaktualizowane po zapisaniu.',
  },
  notificationChannel: 'Kanały powiadomień',
  email: 'E-mail',
};
